import { render, staticRenderFns } from "./DeletePostModal.vue?vue&type=template&id=5b9e5c6c&scoped=true&"
import script from "./DeletePostModal.vue?vue&type=script&lang=ts&"
export * from "./DeletePostModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeletePostModal.vue?vue&type=style&index=0&id=5b9e5c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e5c6c",
  null
  
)

component.options.__file = "DeletePostModal.vue"
export default component.exports